import Vue from "vue";
//import axios from "axios";
import store from "@/app/app-state";
import RestClient from "./restClient";
import { apiUrls } from "@/environment/environment";

const refreshUserContext = class {
  async start() {
    // await this.refreshUserWarehouses();
    // setInterval(this.refreshUserWarehouses, 30000);
    // await this.setUserRightsFromApi();
    setInterval(this.setUserRightsFromApi, 30000);
    // this.setUserName();
    // this.setCompanies();
    // this.setCurrentCompany();
    // this.setCurrentWarehouse();
  }
  async refreshUserWarehouses() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    if (isAuthenticated) {
      let currentCompany = store.state.userContext.currentCompany;
      let currentWarehouse = store.state.userContext.currentWarehouse;
      try {
        let userAPI = apiUrls.user;
        this.client = new RestClient(userAPI);
        this.restClient = new RestClient(userAPI).Instance;
        let response = await this.restClient.get(`Warehouses?companyCode=${currentCompany}&warehouseCode=${currentWarehouse}`);
        store
          .dispatch("userContext/updateWarehouses", response.data)
          .then(d => Vue.$log.debug(d))
          .catch(err => Vue.$log.error(err));
      } catch (error) {
        Vue.$log.error(error);
      }
    }
  }
  async refreshUserRights() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    if (isAuthenticated) {
      try {
        // recuperation des droits de l'API
        let userAPI = apiUrls.user;
        this.client = new RestClient(userAPI);
        this.restClient = new RestClient(userAPI).Instance;
        let response = await this.restClient.get("UserRights");

        let rightsApi = response.data;
        let rights = [];
        rightsApi.forEach(right => {
          rights.push(right.code);
        });

        Vue.$log.debug("NewRights from UserApi: ", rights);
        store
          .dispatch("userContext/updateRights", rights)
          .then(d => Vue.$log.debug(d))
          .catch(err => Vue.$log.error(err));
      } catch (error) {
        //Log
        Vue.$log.error(error);
      }
    }
  }

  setUserName() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    if (isAuthenticated) {
      //TODO a revoir (suppression de Keycloak)
      store.commit("userContext/name", "");
      store.commit("userContext/surname", "");
    }
  }
  setCompanies() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    if (isAuthenticated) {
      let companiesList = [];
      //TODO a revoir (suppression de Keycloak)
      store.commit("userContext/companies", companiesList);
    }
  }
  setCurrentCompany() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    if (isAuthenticated) {
      // TODO a revoir (suppression de Keycloak)
      store.commit("userContext/currentCompany", "");
    }
  }
  setCurrentWarehouse() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    if (isAuthenticated) {
      //TODO a revoir (suppression de Keycloak)
      store.commit("userContext/currentWarehouse", "");
    }
  }

  /**
   * Recuperation des droits de l'API
   */
  async setUserRightsFromApi() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    let currentCompany = store.state.userContext.currentCompany;
    let currentWarehouse = store.state.userContext.currentWarehouse;

    if (isAuthenticated) {
      this.restClient = new RestClient(apiUrls.user).Instance;
      await this.restClient.get(`UserRights?companyCode=${currentCompany}&warehouseCode=${currentWarehouse}`).then(response => {
        if (response.status == 200 || response.status == 204) {
          let rights = [];

          let rightsApi = response.data;

          rightsApi.forEach(right => {
            rights.push(right.code);
          });

          if (Array.isArray(rights)) {
            store.commit("userContext/rights", rights);
          } else {
            Vue.$log.error("Object must be an Array.");
          }
        }
      });
    }
  }

  async setUserInfosFromApi() {
    let isAuthenticated = store.getters["userContext/isAuthenticated"];
    let currentCompany = store.state.userContext.currentCompany;
    let currentWarehouse = store.state.userContext.currentWarehouse;

    if (isAuthenticated) {
      this.restClient = new RestClient(apiUrls.user).Instance;
      await this.restClient.get(`UserInfos?companyCode=${currentCompany}&warehouseCode=${currentWarehouse}`).then(response => {
        if (response.status == 200 || response.status == 204) {
          let datas = response.data;
          store.commit("userContext/name", datas.name);
          store.commit("userContext/surname", datas.surname);
          store.commit("userContext/code", datas.code);
          store.commit("userContext/initials", datas.initials);
        }
      });
    }
  }
};

export default new refreshUserContext();
